import { useEffect, useState } from "react";
import {
  Bell,
  CalendarDays,
  CheckCircle2,
  Clock3,
  Download,
  Home,
  Plus,
  Search,
  ShieldCheck,
  TicketCheck,
  UsersRound,
  WandSparkles,
  Zap,
  BarChart3,
  FilePlus2,
  UserRoundCheck,
  TrendingUp,
  MessageSquareText,
  Sparkles,
  ArrowRight,
  Paperclip,
  MessageSquareMore,
  Info,
} from "lucide-react";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import Breadcrumbs from "./Breadcrumbs";
const avatars = [
  "/avatars/avatar-1.png",
  "/avatars/avatar-2.png",
];

function DeskDashboard() {
  const menuItems = [
    [Home, "Dashboard"],
    [TicketCheck, "Tickets"],
    [CheckCircle2, "My Tasks"],
    [UsersRound, "Customers"],
    [BarChart3, "Reports"],
  ];

  const stats = [
    ["Open Tickets", "128", "blue"],
    ["In Progress", "64", "blue"],
    ["Resolved Today", "23", "green"],
    ["SLA Breached", "5", "red"],
  ];

  const tickets = [
    ["#INC-2458", "Unable to access shared folder", "John Smith", "In Progress"],
    ["#SR-2457", "Email not syncing on mobile", "Sarah Johnson", "Open"],
    ["#SR-2456", "Printer not responding", "Michael Brown", "In Progress"],
    ["#INC-2455", "Request for new laptop", "Emily Davis", "Open"],
  ];

  return (
    <div className="ticket-dashboard">
      <aside className="ticket-dashboard__sidebar">
        <div className="ticket-dashboard__brand">
          <img src="/1.png" alt="Cullath" />
          <strong>cullath</strong>
          <span>DESK</span>
        </div>

        <nav>
          {menuItems.map(([Icon, label], index) => (
            <button className={index === 0 ? "active" : ""} key={label} type="button">
              <Icon size={15} />
              <span>{label}</span>
            </button>
          ))}
        </nav>

        <button className="ticket-dashboard__new" type="button">
          <Plus size={15} /> New Ticket
        </button>
      </aside>

      <section className="ticket-dashboard__workspace">
        <header className="ticket-dashboard__topbar">
          <div className="ticket-dashboard__search">
            <Search size={14} />
            <span>Search tickets...</span>
          </div>
          <Bell size={17} />
          <img src={avatars[1]} alt="Support agent" />
        </header>

        <div className="ticket-dashboard__content">
          <div className="ticket-dashboard__stats">
            {stats.map(([label, value, tone]) => (
              <article key={label}>
                <small>{label}</small>
                <strong>{value}</strong>
                <span className={`ticket-stat ticket-stat--${tone}`}>
                  {tone === "red" ? <Clock3 size={15} /> : <TicketCheck size={15} />}
                </span>
              </article>
            ))}
          </div>

          <div className="ticket-dashboard__columns">
            <section className="ticket-list">
              <p>All Tickets <span>128</span></p>
              {tickets.map(([id, title, owner, status]) => (
                <article key={id}>
                  <i />
                  <div>
                    <small>{id}</small>
                    <strong>{title}</strong>
                    <span>{owner} · IT Support</span>
                  </div>
                  <em>{status}</em>
                </article>
              ))}
            </section>

            <section className="ticket-detail">
              <small>#INC-2458</small>
              <h3>Unable to access shared folder</h3>

              <div className="ticket-detail__person">
                <img src={avatars[0]} alt="John Smith" />
                <div>
                  <strong>John Smith</strong>
                  <span>john.smith@acme.com</span>
                </div>
                <em>High</em>
              </div>

              <div className="ticket-detail__tabs">
                <strong>Details</strong>
                <span>Activity</span>
                <span>Tasks (2)</span>
              </div>

              <p>User is unable to access the shared folder from their computer.</p>

              <div className="ticket-detail__field">
                <span>Assigned to</span>
                <strong>
                  <img src={avatars[1]} alt="James Williams" />
                  James Williams
                </strong>
              </div>

              <div className="ticket-detail__field">
                <span>Due date</span>
                <strong>May 24, 2026</strong>
              </div>

              <div className="ticket-detail__reply">
                <span>Add an internal note...</span>
                <button type="button">Send</button>
              </div>
            </section>

            <aside className="ticket-insights">
              <h3>Ticket Insights</h3>
              <div>
                <small>Resolution Time</small>
                <strong>2h 45m</strong>
                <span>↓ 18%</span>
              </div>
              <div>
                <small>First Response Time</small>
                <strong>45m</strong>
                <span>↓ 22%</span>
              </div>
              <section>
                <WandSparkles size={16} />
                <strong>AI Assistant</strong>
                <button type="button">Summarize ticket</button>
                <button type="button">Suggest response</button>
              </section>
            </aside>
          </div>
        </div>
      </section>
    </div>
  );
}


const featureCards = [
  {
    icon: FilePlus2,
    title: "Request Management",
    copy: "Create, organize, and manage requests from one centralized workspace.",
    demo: "request",
  },
  {
    icon: UserRoundCheck,
    title: "Smart Assignment",
    copy: "Assign tickets to the right team members with clear ownership.",
    demo: "assignment",
  },
  {
    icon: TrendingUp,
    title: "Progress Tracking",
    copy: "Monitor ticket status and keep every task moving forward.",
    demo: "progress",
  },
  {
    icon: ShieldCheck,
    title: "Priority & SLA Management",
    copy: "Prioritize critical requests and stay on top of response timelines.",
    demo: "sla",
  },
  {
    icon: MessageSquareText,
    title: "Team Collaboration",
    copy: "Collaborate through comments, updates, and shared ticket history.",
    demo: "collaboration",
  },
  {
    icon: Sparkles,
    title: "AI Assistance",
    copy: "Summarize tickets, draft responses, and help teams resolve issues faster.",
    demo: "ai",
  },
];

function FeatureDemo({ type }) {
  if (type === "request") {
    return <div className="feature-demo request-demo"><div><small>New Request</small><label>Subject</label><span>Unable to access shared drive</span><label>Category</label><span>IT Support</span><button type="button">Submit Request</button></div><div><small>Recent Requests</small><p>VPN not working <em>Open</em></p><p>Email not syncing <em>In Progress</em></p><p>Printer not responding <em>Resolved</em></p></div></div>;
  }
  if (type === "assignment") {
    return <div className="feature-demo assignment-demo"><div><small>Assign Ticket</small><div className="mini-person"><img src={avatars[0]} alt="Jason Miller"/><span><b>Jason Miller</b>IT Support</span></div><label>Team</label><span>IT Support</span><button type="button">Assign</button></div><div><small>Suggested Assignee</small>{[0,1,0].map((a,i)=><div className="mini-person match" key={i}><img src={avatars[a]} alt="Support agent"/><span><b>{["Jason Miller","Sarah Johnson","Michael Brown"][i]}</b>IT Support</span><em>{[92,84,76][i]}% Match</em></div>)}</div></div>;
  }
  if (type === "progress") {
    return <div className="feature-demo progress-demo"><small>Ticket Progress</small><div className="progress-track"><i className="done"/><i className="active"/><i/><i/></div><div className="progress-labels"><span>Open</span><span>In Progress</span><span>Review</span><span>Resolved</span></div><footer><span>Current Status <em>In Progress</em></span><span>Last Update 10 min ago</span></footer></div>;
  }
  if (type === "sla") {
    return <div className="feature-demo sla-demo"><div><small>Priority</small><p><i className="high"/>High</p><p><i className="medium"/>Medium</p><p><i className="low"/>Low</p></div><div><small>SLA Overview</small><label>Response Time <em>On Track</em></label><span className="meter"><i/></span><label>Resolution Time <em>On Track</em></label><span className="meter second"><i/></span></div></div>;
  }
  if (type === "collaboration") {
    return <div className="feature-demo collaboration-demo"><nav><b>All</b><span>Comments</span><span>History</span><span>Activities</span></nav><div className="comment"><img src={avatars[1]} alt="Emily Davis"/><p><b>Emily Davis</b><small>I’m looking into this issue.</small></p></div><div className="comment delayed"><img src={avatars[0]} alt="Jason Miller"/><p><b>Jason Miller</b><small><strong>@Emily Davis</strong> Please check the latest logs.</small></p></div><div className="comment-box">Add a comment...<button type="button">›</button></div></div>;
  }
  return <div className="feature-demo ai-demo"><div><small>AI Summary</small><p>User is unable to access the shared folder on the company network. It appears to be permission related.</p><button type="button">Generate Summary</button></div><div><small>Suggested Response</small><p>Hi John,<br/><br/>Thanks for reaching out. We’re reviewing the issue and will get back to you shortly.</p><button type="button">Use Response</button></div></div>;
}

function TicketFeatures() {
  return (
    <section className="ticket-features">
      <div className="section-orbit section-orbit--left" />
      <div className="section-orbit section-orbit--right" />
      <div className="ticket-section-heading">
        <span>FEATURES</span>
        <h2>Everything You Need <em>in Help Desk Software</em></h2>
        <p>Cullath Desk combines request management, smart assignment, ticket management, progress tracking, SLA management,
          <a href="https://cullath.com/connect"
                    className="highlight-link">
                  team collaboration
                  </a>
                
                 and AI-powered assistance in one help desk software platform—helping teams resolve requests faster
            from one centralized workspace.</p>
      </div>
      <div className="ticket-feature-grid">
        {featureCards.map(({ icon: Icon, title, copy, demo }, index) => (
          <article className="ticket-feature-card" style={{ "--delay": `${index * 120}ms` }} key={title}>
            <header><span><Icon size={27}/></span><div><h3>{title}</h3><p>{copy}</p></div></header>
            <FeatureDemo type={demo}/>
          </article>
        ))}
      </div>
      <div className="ticket-section-note"><ShieldCheck size={18}/> Built with enterprise-grade <b>security, automation, and intelligence.</b></div>
    </section>
  );
}

const livePhases = [
  { label: "Request received", status: "New", note: "Customer message converted into a ticket" },
  { label: "Assignment routing", status: "Assigned", note: "Ticket appears in the team queue and gets assigned" },
  { label: "Work in progress", status: "Pending", note: "Support responds and the ticket waits for the next action" },
  { label: "Team collaboration", status: "Pending", note: "Conversation continues while the owner tracks the request" },
  { label: "Issue resolved", status: "Resolved", note: "Customer is updated and the request is closed" },
];

function RequestReceivedView() {
  return (
    <div className="stage-shell request-stage">
      <header className="stage-header-row">
        <h4>Conversation History</h4>
      </header>

      <div className="history-thread">
        <div className="thread-rail">
          <span className="thread-icon thread-icon--ticket"><TicketCheck size={16} /></span>
          <span className="thread-line" />
          <span className="thread-icon thread-icon--reply"><MessageSquareMore size={16} /></span>
        </div>

        <article className="history-card history-card--created">
          <div className="history-card__top">
            <div className="identity-chip">P</div>
            <div className="history-card__meta">
              <div className="history-card__title"><strong>Olivia Carter</strong><em>Ticket Created</em></div>
              <small>To: Ethan Walker</small>
            </div>
            <time>14 Jul 2026 07:23 pm</time>
          </div>

          <div className="history-card__bubble">
            Is this ticketing system limiting the number of words or characters that can be entered? Please see the attached image. I have tried submitting my response a couple of times, but it still isn't sending the complete sentences.
          </div>

          <div className="history-card__tags">
            <span className="tag-open">Open</span>
            <span className="tag-soft">Individual Ticket</span>
          </div>

          <div className="history-card__attachment">
            <strong><Paperclip size={14} /> Attachments</strong>
            <button type="button">Ticket.png</button>
          </div>
        </article>
      </div>
    </div>
  );
}

function AssignmentQueueView() {
  return (
    <div className="stage-shell assignment-stage">
      <header className="stage-header-row stage-header-row--table">
        <div>
          <h4>Team Tickets</h4>
          <span><Info size={14} /> Live routing</span>
        </div>
      </header>

      <div className="team-ticket-table">
        <div className="team-ticket-table__head">
          <span>Ticket ID</span>
          <span>PSN</span>
          <span>Subject</span>
          <span>Created By</span>
          <span>Assigned To</span>
          <span>Priority</span>
          <span>Status</span>
          <span>Created Date</span>
          <span>Latest Reply</span>
          <span>Last Updated By</span>
        </div>

        <article className="team-ticket-row team-ticket-row--live">
          <span>T-OVKGL</span>
          <span>-</span>
          <span>
            <small>Ticket Limit</small>
            <strong>Yes, currently system is limited to take 50...</strong>
          </span>
          <span>Olivia Carter</span>
          <span>Ethan Walker</span>
          <span><em className="pill pill--low">Low</em></span>
          <span><em className="pill pill--pending">Pending</em></span>
          <span>14 July 2026</span>
          <span>15 July 2026</span>
          <span><em className="pill pill--ghost">Ethan Walker</em></span>
        </article>

        <article className="team-ticket-row">
          <span>T-7UW5Z</span>
          <span>DDA</span>
          <span>
            <small>Need Clarification</small>
            <strong>Ava Mitchell reassigned ticket to Divy...</strong>
          </span>
          <span>Ethan Walker</span>
          <span>Noah Bennett</span>
          <span><em className="pill pill--low">Low</em></span>
          <span><em className="pill pill--open">Open</em></span>
          <span>26 June 2026</span>
          <span>26 June 2026</span>
          <span><em className="pill pill--ghost">Ava Mitchell</em></span>
        </article>
      </div>
    </div>
  );
}

function ProgressConversationView({ resolved = false }) {
  return (
    <div className={`stage-shell progress-stage ${resolved ? "is-resolved" : ""}`}>
      <header className="stage-header-row">
        <h4>Conversation History</h4>
      </header>

      <div className="history-thread progress-thread">
        <div className="thread-rail">
          <span className="thread-icon thread-icon--reply"><MessageSquareMore size={16} /></span>
          <span className="thread-line" />
          <span className="thread-icon thread-icon--reply active"><MessageSquareMore size={16} /></span>
        </div>

        <article className="history-card history-card--reply current-request">
          <div className="history-card__top">
            <div className="identity-chip identity-chip--blue">SR</div>
            <div className="history-card__meta">
              <div className="history-card__title"><strong>Ethan Walker</strong><em>Reply</em></div>
              <small>To: Olivia Carter</small>
            </div>
            <time>15 Jul 2026 08:46 am</time>
          </div>

          <div className="history-card__bubble history-card__bubble--reply">
            Yes, Currently system is limited to take 500 Characters in the backend.<br />
            I have increase the limit for Long Text. Now you are able to send long text.<br /><br />
            Thanks
          </div>

          <div className="history-card__tags history-card__tags--single">
            <span className={resolved ? "tag-resolved" : "tag-pending"}>{resolved ? "Resolved" : "Pending"}</span>
          </div>
        </article>
      </div>
    </div>
  );
}

function TicketLifecycle() {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    document.title = "Help Desk Software for Modern Teams | Cullath Desk";

  const description =
    "Modern help desk software for managing tickets, requests, assignments, and team support from one centralized workspace.";

    const id = window.setInterval(() => {
      setPhase((current) => (current + 1) % livePhases.length);
    }, 3200);
    return () => window.clearInterval(id);
  }, []);
  useEffect(() => {
  const canonicalUrl = "https://cullath.com/desk";

  let canonical = document.querySelector('link[rel="canonical"]');

  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.setAttribute("href", canonicalUrl);

  return () => {
    canonical.remove();
  };
}, []);

  const steps = [
    {
      icon: Bell,
      title: "Request received",
      copy: "Customer message converted into a ticket",
      visual: (
        <div className="journey-inbox">
          <span className="journey-inbox__pulse" />
          <div><small>New customer message</small><strong>Shared folder access issue</strong></div>
          <em>Converted</em>
        </div>
      ),
    },
    {
      icon: UsersRound,
      title: "Assignment routing",
      copy: "Ticket appears in the team queue and gets assigned",
      visual: (
        <div className="journey-routing">
          <span><img src={avatars[0]} alt="Olivia Carter" /><b>Olivia Carter</b></span>
          <i><ArrowRight size={18} /></i>
          <span><img src={avatars[1]} alt="Ethan Walker" /><b>Ethan Walker</b></span>
        </div>
      ),
    },
    {
      icon: Clock3,
      title: "Work in progress",
      copy: "Support responds and the ticket waits for the next action",
      visual: (
        <div className="journey-progress">
          <div><span>Agent response</span><b>Sending update...</b></div>
          <i><span /></i>
          <small>Waiting for customer</small>
        </div>
      ),
    },
    {
      icon: MessageSquareMore,
      title: "Team collaboration",
      copy: "Conversation continues while the owner tracks the request",
      visual: (
        <div className="journey-chat">
          <p><img src={avatars[1]} alt="Ethan Walker" /><span><b>Ethan</b> Permissions are updated.</span></p>
          <p><img src={avatars[0]} alt="Olivia Carter" /><span><b>Olivia</b> I’ll confirm with the customer.</span></p>
          <div><i /><i /><i /></div>
        </div>
      ),
    },
    {
      icon: CheckCircle2,
      title: "Issue resolved",
      copy: "Customer is updated and the request is closed",
      visual: (
        <div className="journey-resolved">
          <span><CheckCircle2 size={30} /></span>
          <div><strong>Resolution complete</strong><small>Customer notified · Ticket closed</small></div>
        </div>
      ),
    },
  ];

  return (
    <section className="ticket-live-showcase ticket-journey">
      <div className="ticket-section-heading compact">
        <span>WORKFLOW IN MOTION</span>
        <h2>See Every Support<br /><em>Request Move Forward</em></h2>
        <p>
          Follow every support request from initial submission through assignment, collaboration, progress tracking,
           and final resolution—all within one centralized help desk software platform that keeps your team organized and responsive.
        </p>
      </div>

      <div className="journey-shell">
        <div className="journey-progress-line">
          <i style={{ width: `${((phase + 1) / steps.length) * 100}%` }} />
        </div>

        <div className="journey-grid">
          {steps.map(({ icon: Icon, title, copy, visual }, index) => (
            <article
              className={`journey-card ${index === phase ? "is-active" : ""} ${index < phase ? "is-complete" : ""}`}
              key={title}
              onMouseEnter={() => setPhase(index)}
            >
              <header>
                <span>{index < phase ? <CheckCircle2 size={19} /> : <Icon size={19} />}</span>
                <small>0{index + 1}</small>
              </header>
              <div className="journey-card__visual" key={`${phase}-${index}`}>{visual}</div>
              <h3>{title}</h3>
              <p>{copy}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

function TicketDeskCtaSection() {
  return (
    <section className="ticket-desk-cta ticket-desk-cta--bar">
      <div className="ticket-desk-cta__bar-inner">
        <div className="ticket-desk-cta__bar-copy">
          <span className="ticket-desk-cta__eyebrow">GET STARTED WITH DESK</span>
          <h2>Ready to Simplify <span>Your Help Desk?</span></h2>
          <p>
            Bring support requests, ticket management, assignments, collaboration, and progress tracking 
            together in one modern help desk software platform. See how Cullath Desk helps your team resolve issues faster and deliver better support.
          </p>
          <div className="ticket-desk-cta__actions">
            <a href="/contact-us"><CalendarDays size={18} /> Request a Demo <ArrowRight size={17} /></a>
            <a className="secondary" href="https://connect.cullath.com/desktop/Cullath.exe"><Download size={18} /> Download</a>
          </div>
        </div>

        <div className="ticket-desk-cta__benefits ticket-desk-cta__benefits--bar">
          <article><span><ShieldCheck size={20} /></span><div><strong>Secure & Reliable</strong><small>Enterprise-grade security</small></div></article>
          <article><span><CheckCircle2 size={20} /></span><div><strong>Easy to Deploy</strong><small>Quick setup, fast adoption</small></div></article>
          <article><span><UsersRound size={20} /></span><div><strong>Built for Teams</strong><small>Scalable for any team size</small></div></article>
        </div>
      </div>
    </section>
  );
}

export default function TicketingPage() {
  return (
    <div className="ticket-page">
      <SiteHeader isHeroPage />

      <main>
        <section className="ticket-hero">
          <div className="ticket-hero__orbit ticket-hero__orbit--left" />
          <div className="ticket-hero__orbit ticket-hero__orbit--right" />

          <div className="ticket-hero__container">
            <div className="ticket-hero__copy">
              <Breadcrumbs items={[{ label: "Home", href: "/" }, { label: "Products", href: "/#product" }, { label: "Desk" }]} />
              <span className="ticket-hero__eyebrow">CULLATH DESK</span>

              <h1>
                <span className="ticket-hero__line">Help Desk Software </span>
                <span className="ticket-hero__line ticket-hero__line--accent">for Modern Teams</span>
              </h1>

              <p>
                Cullath Desk is modern help desk software that helps teams manage support requests, track tickets, assign tasks, and resolve issues 
                faster from one centralized workspace. Built for growing businesses, it streamlines ticket management and improves service efficiency.
              </p>

              <div className="ticket-hero__actions">
                <a href="/contact-us">
                  <CalendarDays size={18} /> Request a Demo
                </a>
                <a className="secondary" href="https://connect.cullath.com/desktop/Cullath.exe">
                  <Download size={18} /> Download 
                </a>
              </div>

              <div className="ticket-hero__benefits">
                <article>
                  <span><ShieldCheck size={18} /></span>
                  <div><strong>Enterprise Ready</strong><small>Secure. Reliable. Scalable.</small></div>
                </article>
                <article>
                  <span><UsersRound size={18} /></span>
                  <div><strong>Built for Teams</strong><small>Collaborate with ease.</small></div>
                </article>
                <article>
                  <span><Zap size={18} /></span>
                  <div><strong>Work Smarter</strong><small>Automate. Track. Resolve.</small></div>
                </article>
              </div>
            </div>

            <div className="ticket-hero__visual">
              <DeskDashboard />
            </div>
          </div>
        </section>
        <TicketFeatures />
        <TicketLifecycle />
          <TicketDeskCtaSection />
      </main>
      <SiteFooter />
    </div>
  );
}
